import { getUiPictureTemplate } from '@front-box/Media/UiPicture/UiPictureTemplate'
import { UiButtonVanilla } from '@front-box/Buttons/UiButton/UiButtonVanilla'
import { getUiSocialButtonTemplate } from '@front-box/Buttons/UiSocialButton/UiSocialButtonTemplate'
import UiModal from '../UiModal/UiModal'
import { createElement } from '../../utils/render'

const TypeToName = {
  telegram: 'Telegram',
  vk: 'ВКонтакте',
  max: 'MAX'
}

const MULTI_CHANNELS = ['vk', 'telegram', 'max']

const getHref = (type, requestId) => {
  switch (type) {
    case 'max':
      return `https://refer.id/?bot=skillbox_bot&platform=max&verbose_name=skillbox_bot&n=173798&c=11203&request_id=${requestId}`
    case 'vk':
      return `https://refer.id/?bot=66669811&platform=vkontakte&verbose_name=Skillbox&vk_app_id=7156066&bot_avatar=https://getmybot.storage.yandexcloud.net/uploads/bot_avatars/skb.png&n=173798&c=11203&request_id=${requestId}`
    default:
      return `https://refer.id/?bot=skillbox_main_bot&platform=telegram&verbose_name=Skillbox&bot_avatar=https://getmybot.storage.yandexcloud.net/uploads/bot_avatars/skb.png&n=173798&c=11203&request_id=${requestId}`
  }
}

const images = {
  sm: {
    img: {
      '1x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/communication/communication-icon@1x.png',
      '2x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/communication/communication-icon@2x.png'
    },
    webp: {
      '1x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/communication/communication-icon@1x.webp',
      '2x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/communication/communication-icon@2x.webp'
    }
  }
}

const getSingleButton = (type, requestId) => (
  UiButtonVanilla({
    size: 'big',
    stretch: true,
    title: `Перейти в ${TypeToName[type]}`,
    href: getHref(type, requestId),
    classes: 'communication-modal__button',
    attrs: `data-channel="${type}" target=_blank rel="noopener noreferrer"`
  })
)

const getMultiButtons = (requestId) => (
  `<ul class="communication-modal__buttons">
    ${MULTI_CHANNELS.map((type) => (
      `<li class="communication-modal__buttons-item">
        ${getUiSocialButtonTemplate({
          type,
          title: TypeToName[type],
          href: getHref(type, requestId),
          size: 'big',
          stretch: true,
          classes: `communication-modal__button communication-modal__social-button--${type}`,
          attrs: `data-channel="${type}" rel="noopener noreferrer"`
        })}
      </li>`
    )).join('')}
  </ul>`
)

const getData = (type, requestId) => {
  switch (type) {
    case 'telegram':
    case 'vk':
    case 'max':
      return {
        title: `Чтобы мы&nbsp;могли вам написать, запустите бота в&nbsp;${TypeToName[type]}`,
        description: `${TypeToName[type]} не&nbsp;позволяет отправлять сообщения первым. Запустите&nbsp;бота&nbsp;&mdash; и&nbsp;наш менеджер свяжется с&nbsp;вами.`,
        buttons: getSingleButton(type, requestId)
      }
    default:
      return {
        title: 'Больше скидок и&nbsp;интересных событий в&nbsp;наших чат-ботах',
        description: 'Подпишитесь на&nbsp;любой из&nbsp;наших чат-ботов, чтобы не&nbsp;пропустить скидки и&nbsp;узнать больше об&nbsp;обучении в&nbsp;Skillbox',
        buttons: getMultiButtons(requestId)
      }
  }
}

const getCommunicationModalTemplate = ({ title, description, buttons }) => {
  return (
    `<div class="communication-modal__wrapper">
      ${getUiPictureTemplate({
        imagesData: images,
        className: 'communication-modal__picture',
        width: 120,
        height: 120,
        isLazy: false,
        decoding: 'sync'
      })}

      <h2 class="communication-modal__title t t--1">
        ${title}
      </h2>

      <p class="communication-modal__description f f--14">
        ${description}
      </p>

      ${buttons}
    </div>`
  )
}

class CommunicationModal extends UiModal {
  constructor(template, blockName, type) {
    super(template, {
      wrapperClass: 'communication-modal',
      isIndent: false,
      blockTriggerName: blockName
    });

    this._type = type;
  }

  mounted() {
    super.mounted();

    window.$analytics?.push('communication-modal-shown', { type: this._type });
  }

  beforeClose() {
    window.$analytics?.push('communication-modal-skipped', { type: this._type });
  }

  beforeMounted() {
    this.element.addEventListener('click', this._clickButtonHandler);
  }

  beforeUnmounted() {
    this.element.removeEventListener('click', this._clickButtonHandler);
  }

  _clickButtonHandler = (evt) => {
    const button = evt.target.closest('.communication-modal__button');

    if (!button) {
      return;
    }

    window.$analytics?.push('communication-modal-form-sent', { type: button.dataset.channel });
    this.close();
  }
}

export const showCommunicationModal = (type, blockName, requestId) => {
  const data = getData(type, requestId)
  const template = createElement(getCommunicationModalTemplate(data))

  new CommunicationModal(template, blockName, type).init()
}
